/**
 * A FIGURE'S CHANGE, SAID QUIETLY (design 18; the owner, 2026-10-05: "Quiet arrow, counts for small
 * numbers"): a small arrow in the direction's colour and the change in plain words beside it -
 * "↑ 12%", "↓ 6 fewer", "– no change". Only the arrow is coloured; the words keep the text colour, so
 * a drop on a handful of comments no longer reads as an alarm (Plausible's `ChangeArrow` and Ghost's
 * `TrendBadge` do the same).
 *
 * The arrow is decoration (`aria-hidden`): the words carry the direction too, and a screen reader
 * hears `says` - "6 fewer than the previous period" - instead of the short form. The wording, and
 * when there is a change at all, is `changeBetween`'s (../ranges.ts); this file only draws it.
 */
import { VisuallyHidden } from '@mantine/core';
import { ArrowDownRight, ArrowUpRight, Minus } from '@moonx/ui';
import type { StatDelta } from './kit';
import classes from './figures.module.css';

export function ChangeNote({ change }: { readonly change: StatDelta }) {
  const Arrow =
    change.tone === 'up' ? ArrowUpRight : change.tone === 'down' ? ArrowDownRight : Minus;
  return (
    <span className={classes.change} data-tone={change.tone}>
      <Arrow size={13} strokeWidth={2.4} aria-hidden className={classes.changeArrow} />
      {change.says === undefined ? (
        change.text
      ) : (
        <>
          <span aria-hidden="true">{change.text}</span>
          <VisuallyHidden>{change.says}</VisuallyHidden>
        </>
      )}
    </span>
  );
}
